import { Component, HostListener, OnInit } from '@angular/core';
import { ServicesSunsetService } from '../services-sunset.service';
import { ChartOptions, ChartType, Chart } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./home.component.css']
})
export class InicioComponent implements OnInit {

  activar: number = 0;
  logo: number =0;
  usuario: string;
  saludos: string;

  
 
  constructor(private _servicios:ServicesSunsetService) { 

  
  }

  ngOnInit() {

    
    const hora = new Date();

    this.saludos = "Buenos días, ";

    if (hora.getHours() > 12) {

      this.saludos = "Buenas tardes, ";


    }

    if (hora.getHours() > 18) {

      this.saludos = "Buenas noches, ";


    }

    this.usuario = sessionStorage.getItem('usuario').toString();


  
  }


  click_burguer() {

    this.activar ++;
   
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
   
    this.logo = window.innerWidth;
  
  }


}
